import(/* webpackMode: "eager" */ "/vercel/path0/src/app/council/environmental/page.tsx");
